import React, { useState, useRef, useEffect } from "react";
import Barcode from "react-barcode";
import { toPng } from "html-to-image";
import jsPDF from "jspdf";
import "./barcode reader.css";

function BarcodeGenerator() {
  const [barcodeValue, setBarcodeValue] = useState("");
  const [productCode, setProductCode] = useState("");
  const [price, setPrice] = useState("");
  const barcodeRef = useRef(null);
  const [barcodeWidth, setBarcodeWidth] = useState(2.5);

  useEffect(() => {
    if (barcodeValue) {
      const length = barcodeValue.length;
      let newWidth;
      
      if (length <= 8) newWidth = 4.0;
      else if (length <= 12) newWidth = 3.5;
      else if (length <= 16) newWidth = 3.0;
      else newWidth = 2.5;
      
      setBarcodeWidth(newWidth);
    }
  }, [barcodeValue]);

  const handleDownload = async () => {
    if (!barcodeRef.current) return;

    try {
      const element = barcodeRef.current;
      
      // Force barcode to render before capture
      await new Promise(resolve => setTimeout(resolve, 100));
      
      const dataUrl = await toPng(element, {
        backgroundColor: '#FFFFFF',
        pixelRatio: 6,
        quality: 1,
        width: 900,
        height: 150,
        skipAutoScale: true,
        style: {
          transform: 'scale(1)'
        }
      });

      const pdf = new jsPDF({
        unit: 'mm',
        format: [90, 15],
        orientation: 'landscape'
      });

      pdf.addImage(
        dataUrl,
        'PNG',
        0, 0,
        90, 15
      );

      pdf.save(`${barcodeValue || "barcode"}.pdf`);

    } catch (err) {
      console.error("Error generating PDF:", err);
      alert("Error generating PDF. Please try again.");
    }
  };

  return (
    <div className="barcode-app">
      <div className="input-section">
        <h1 className="app-title">Barcode Label Generator</h1>

        <div className="input-group">
          <label>Barcode Value *</label>
          <input
            type="text"
            value={barcodeValue}
            onChange={(e) => setBarcodeValue(e.target.value)}
            placeholder="e.g., C04818001"
            maxLength={20}
          />
        </div>

        <div className="input-group">
          <label>Product Code</label>
          <input
            type="text"
            value={productCode}
            onChange={(e) => setProductCode(e.target.value)}
            placeholder="e.g., CHP-630 52 17 142"
          />
        </div>

        <div className="input-group">
          <label>Price</label>
          <input
            type="text"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
            placeholder="e.g., 9500/-"
          />
        </div>
      </div>

      {/* PREVIEW PANEL */}
      <div className="preview-container" style={{
        marginTop: '20px',
        padding: '20px',
        backgroundColor: '#f5f5f5',
        borderRadius: '8px',
        textAlign: 'center'
      }}>
        <h3 style={{ marginBottom: '15px' }}>Preview</h3>
        
        {/* THE LABEL - Normal size for preview */}
        <div 
          ref={barcodeRef}
          style={{
            width: '900px',
            height: '150px',
            display: 'flex',
            backgroundColor: 'white',
            border: '2px solid #333',
            padding: 0,
            margin: '0 auto',
            boxSizing: 'border-box',
            overflow: 'hidden',
            flexShrink: 0
          }}
        >
          {/* SECTION 1: BLANK */}
          <div style={{
            width: '300px',
            height: '150px',
            backgroundColor: 'white',
            flexShrink: 0
          }}>
            {/* EMPTY */}
          </div>

          {/* SECTION 2: BARCODE ONLY */}
          <div style={{
            width: '300px',
            height: '150px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'white',
            flexShrink: 0,
            padding: 0,
            boxSizing: 'border-box'
          }}>
            {barcodeValue ? (
              <Barcode
                value={barcodeValue}
                format="CODE128"
                width={barcodeWidth}
                height={100}
                displayValue={false}
                background="transparent"
                margin={0}
                fontSize={0}
                lineColor="#000000"
              />
            ) : (
              <div style={{ fontSize: '14px', color: '#999' }}>No barcode</div>
            )}
          </div>

          {/* SECTION 3: PRODUCT CODE + PRICE */}
          <div style={{
            width: '300px',
            height: '150px',
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: 'white',
            flexShrink: 0,
            padding: 0,
            boxSizing: 'border-box',
            justifyContent: 'center',
            alignItems: 'center'
          }}>
            {/* Product Code */}
            <div style={{
              height: '70px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderBottom: '2px solid #000',
              width: '100%',
              flexShrink: 0
            }}>
              <p style={{
                margin: 0,
                fontSize: '18px',
                fontWeight: 'bold',
                textAlign: 'center',
                color: '#000',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                padding: '0 10px',
                width: '100%'
              }}>
                {productCode || 'Product Code'}
              </p>
            </div>
            
            {/* Price */}
            <div style={{
              height: '70px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              flexShrink: 0
            }}>
              <p style={{
                margin: 0,
                fontSize: '28px',
                fontWeight: 'bold',
                textAlign: 'center',
                color: '#000'
              }}>
                {price || 'Price'}
              </p>
            </div>
          </div>
        </div>
      </div>

      <button
        className="download-btn"
        onClick={handleDownload}
        disabled={!barcodeValue}
        style={{
          marginTop: '20px',
          padding: '12px 30px',
          fontSize: '16px',
          backgroundColor: '#007bff',
          color: 'white',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer'
        }}
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" style={{ marginRight: '8px' }}>
          <path
            d="M12 15V3M12 15L8 11M12 15L16 11M21 15V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V15"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        Download PDF
      </button>
    </div>
  );
}

export default BarcodeGenerator;